'use strict';
import 'rxjs/add/operator/combineLatest';
import {mapPropsStream} from 'recompose';
import {createToggleState} from '../../../core-utilities/react-utils';
import {TaskViewBannerView} from './TaskViewBannerView';


export const StreamedComponent = (props$) => {
  const {
    handler: onToggleHeaderExpanded,
    stream: isHeaderExpanded$,
  } = createToggleState(props$);

  return props$
    .combineLatest(
      isHeaderExpanded$,
      (props, isHeaderExpanded) => ({
        ...props,
        isHeaderExpanded,
        onToggleHeaderExpanded,
      }));
};

export const TaskViewBannerComponent = mapPropsStream(StreamedComponent)(TaskViewBannerView);



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewBanner/TaskViewBannerComponent.js